import { render, staticRenderFns, recyclableRender, components } from "./weblogin.vue?vue&type=template&id=0bcfc898&scoped=true&"
var renderjs
import script from "./weblogin.vue?vue&type=script&lang=js&"
export * from "./weblogin.vue?vue&type=script&lang=js&"
import style0 from "./weblogin.vue?vue&type=style&index=0&id=0bcfc898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcfc898",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/login/weblogin.vue"
export default component.exports